// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { IFormTrailer } from '~/utils/interface/trailer';

export const schema = (t: TFunction): yup.ObjectSchema<IFormTrailer> => {
  return yup.object().shape({
    name: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    status: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    trailerType: yup.string().optional(),
    rentalStatus: yup.string().optional(),
    note: yup.string().optional(),
  });
};

export const defaultValuesTrailerForm: IFormTrailer = {
  name: EMPTY_STRING,
  trailerType: EMPTY_STRING,
  rentalStatus: EMPTY_STRING,
  status: EMPTY_STRING,
  note: EMPTY_STRING,
};
